/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Components, Theme } from "@mui/material/styles";

export const muiCardStyle = (): Components<Theme>["MuiCard"] => ({
  defaultProps: {
    elevation: 8,
  },
});
